import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/playground')({
  component: PlaygroundLayout
})

function PlaygroundLayout() {
  return <Outlet />
}
